export interface ThemeTemplateModel {
  id?: string;
  name: string;
  slug: string;
  key?: string;
  value: any;
}

export interface ThemeTemplateItem {
  name: string;
  type: ThemeType;
  value: any;
}

export interface SearchThemeTemplateRequestModel {
  slug?: string;
  page: number;
  pageSize: number;
}

export enum ThemeType {
  Group,
  GroupList,
  Image,
  ImageList,
  TextNormal,
  TextHtml,
  TextLink,
}

export const ThemeTypeText = [
  "Nhóm phần tử",
  "Danh sách nhóm phần tử",
  "Hình ảnh",
  "Danh sách hình ảnh",
  "Chữ bình thường",
  "Chữ HTML",
  "Đường dẫn",
];
